import * as React from 'react';
import * as styles from './DetailsList.css';
import { IAIcon } from '../../icon/Icon';
import { LocalizationService } from '../../../services/LocalizationService';

export interface IProps {
  columnHeadlines: any[];
  rows: any[];
}

export class IADetailsList extends React.Component<IProps> {

  private readonly localizationService: LocalizationService = new LocalizationService();

  public componentDidMount(): void {
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    return (
      <div className={styles.IA_detailsList}>
        <table>
          <tr>
            {this.props.columnHeadlines}
          </tr>
          {this.props.rows}
        </table>
        {this.props.rows == undefined &&
          <div key={"loader"} className={styles.loader}></div>
        }
        {this.props.rows != undefined && this.props.rows.length == 0 &&
          <div
            key={`NoContent`}
            className={styles.IA_noContent}
          >
            <IAIcon
              title="Info"
              size={25}
              color={"#999999"}
            />
            {this.localizationService.strings.Analytics_NoData}
          </div>
        }
      </div>
    );
  }
}